module.exports = __webpack_public_path__ + "media/images/businessman-36f3d9abfe8d8a91614f7dbba02adf72.svg";